export default {
  setDialogSignIn(state, val) {
    state.dialogSignIn = val;
  },
  setDialogLogin(state, val) {
    state.dialogLogin = val;
  },
  setChangePwd(state, val) {
    state.dialogChangePwd = val;
  },
  setUserInfo(state, val) {
    state.userInfo = val;
  },
  setNav(state, val) {
    state.head_nav = val;
  },
  setMeNav(state, val) {
    state.me_active_nav = val;
  },
  setCity_info(state, val) {
    state.city_name = val;
  },
  setCategoryName(state, val) {
    state.category_name = val;
  },
  setToken(state, token) {
    state.token = token
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js